module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Price #2-40cfd906c7739c9b07fe5487517082b2.svg";